module.exports = __webpack_public_path__ + "static/img/img-1.1855086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/img-1.png
// module id = ccJa
// module chunks = 10